import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { SchedulerEvent } from '@progress/kendo-angular-scheduler';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BasicBrickComponent } from 'src/app/components/bricks/basic-brick-component';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { AppointmentTypeEnum } from 'src/app/store/dashboard/appointments/AppointmentTypeEnum';
import { AppointmentEntryRemoteDto } from 'src/generated/signalR/appointment-entry-remote-dto';

@Component({
   selector: 'samweb-appointment-schedule',
   templateUrl: './appointment-schedule.component.html',
   styleUrls: ['./appointment-schedule.component.scss'],
})
export class AppointmentScheduleComponent extends BasicBrickComponent implements OnInit {
   @Input()
   public appointments$: Observable<AppointmentEntryRemoteDto[]>;

   @Input()
   public currentView$: Observable<number>;

   @Input()
   public showBusinessHours$: Observable<number>;

   @Input()
   public doShowExchangeAppointmentSubjects$: Observable<boolean>;

   public events$: Observable<SchedulerEvent[]>;

   public selectedDate: Date = moment(moment.now()).toDate();

   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;

   @Output()
   public closeScheduler = new EventEmitter();

   @Output()
   public viewIndexChange = new EventEmitter<number>();

   constructor(private translateService: TranslateService) {
      super();
   }

   ngOnInit(): void {
      this.events$ = this.doShowExchangeAppointmentSubjects$.pipe(
         switchMap((doShowExchangeAppointmentSubjects) =>
            this.appointments$.pipe(
               map((appointments) => {
                  const result: SchedulerEvent[] = [];
                  appointments.forEach((appointment) => {
                     result.push({
                        id: appointment.id,
                        title: doShowExchangeAppointmentSubjects
                           ? appointment.comment
                           : this.translateService.instant('brick.brick_definitions.directory_browser.columns.appointments.appointment_subject'),
                        start: appointment.start,
                        end: appointment.end,
                        isAllDay: AppointmentTypeEnum.fromAppointment(appointment) === AppointmentTypeEnum.WHOLE_DAY,
                     });
                  });
                  return result;
               })
            )
         )
      );
   }
   public close() {
      this.closeScheduler.emit();
   }

   onViewIndexChange(e: number): void {
      this.viewIndexChange.emit(e);
   }
}
